import { render, staticRenderFns } from "./testimonal.vue?vue&type=template&id=79b676ac&"
import script from "./testimonal.vue?vue&type=script&lang=js&"
export * from "./testimonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports